import * as React from 'react'
import { styled } from 'next-yak'

import { SliderButton } from '../button/SliderButton'
import * as S from '../../styles/carousel'
import * as hooks from '../../hooks'

type SlidingCarouselProps = {
  children: React.ReactNode
  style?: React.CSSProperties
  className?: string
  $scrollOffset?: number
  $verticalOnMobile?: boolean
}

function SlidingCarouselComponent({
  children,
  style,
  className,
  $scrollOffset = 280,
  $verticalOnMobile = false,
}: SlidingCarouselProps): React.ReactElement<any> {
  const $carouselRef = React.useRef<HTMLDivElement | null>(null)

  const [canScrollRight, setCanScrollRight] = React.useState(true)
  const [canScrollLeft, setCanScrollLeft] = React.useState(false)
  const [contentIsScrollable, setContentAsScrollable] = React.useState(true)

  hooks.useScrollableListener($carouselRef, (scrollable) => {
    setContentAsScrollable(scrollable.x)
  })

  hooks.useScrollListener($carouselRef, () => {
    if (contentIsScrollable) {
      if ($carouselRef.current && $carouselRef.current?.clientWidth !== $carouselRef.current?.scrollWidth) {
        setCanScrollLeft($carouselRef.current.scrollLeft > 0)
        setCanScrollRight(
          $carouselRef.current.scrollWidth - $carouselRef.current.scrollLeft !== $carouselRef.current.clientWidth,
        )
      }
    }
  })

  hooks.useIsoLayoutEffect(() => {
    if ($carouselRef.current) {
      $carouselRef.current.scrollLeft = 0
    }
  }, [children])

  const handleScrollLeft = (): void => {
    if ($carouselRef.current) {
      $carouselRef.current.scrollLeft -= $scrollOffset
    }
  }

  const handleScrollRight = (): void => {
    if ($carouselRef.current) {
      $carouselRef.current.scrollLeft += $scrollOffset
    }
  }

  return (
    <S.SlidingWrapper>
      {contentIsScrollable && (
        <S.SlidingControlWrapper>
          <S.SlidingControlButtons>
            <SliderButton direction="left" disabled={!canScrollLeft} onClick={handleScrollLeft} />
            <SliderButton direction="right" disabled={!canScrollRight} onClick={handleScrollRight} />
          </S.SlidingControlButtons>
        </S.SlidingControlWrapper>
      )}
      <S.SlidingCarouselWrapper
        className={className}
        style={style}
        ref={$carouselRef}
        $verticalOnMobile={$verticalOnMobile}
      >
        {children}
      </S.SlidingCarouselWrapper>
    </S.SlidingWrapper>
  )
}

export const SlidingCarousel = styled(SlidingCarouselComponent)``
